var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F36",
    d: "M6.103 4.288v2.418h2.991l-.473 3.258H6.103v7.507a11.3 11.3 0 0 1-3.323-.035V9.964H.021V6.706h2.76v-2.96A3.324 3.324 0 0 1 6.103.423v.001L6.12.422h2.975V3.24H7.151c-.578 0-1.047.469-1.047 1.047"
  })));
};
export default SvgFacebook;